import { useState } from 'react';
import { STATUS_OPTIONS } from './ApplicationForm';
import { useTranslation } from 'react-i18next';

const STATUS_COLORS = {
    applied: '#3b82f6',
    interview: '#f59e0b',
    offer: '#10b981',
    rejected: '#ef4444',
    withdrawn: '#6b7280',
};

function KanbanCard({ app, isSelected, onSelect, onStatusChange, onDelete, onAddNote }) {
    const { t } = useTranslation();
    const [noteText, setNoteText] = useState('');
    const [showNoteForm, setShowNoteForm] = useState(false);

    const handleAddNote = () => {
        if (!noteText.trim()) return;
        onAddNote(app.id, noteText.trim());
        setNoteText('');
        setShowNoteForm(false);
    };

    return (
        <div
            className="kanban-card"
            onClick={() => onSelect(app.id)}
        >
            <strong>{app.position}</strong>
            <p>{app.company_name}</p>
            {app.applied_date && (
                <small>{t('internships.applied_date')}: {app.applied_date}</small>
            )}
            {app.job_description && (
                <small style={{ color: '#10b981', display: 'block' }}>
                    {t('internships.job_description_added')}
                </small>
            )}

            {isSelected && (
                <div
                    className="card-expanded"
                    onClick={e => e.stopPropagation()}
                >
                    <div className="form-group">
                        <label>{t('internships.update_status')}</label>
                        <select
                            value={app.status}
                            onChange={e => onStatusChange(app.id, e.target.value)}
                        >
                            {STATUS_OPTIONS.map(s => (
                                <option key={s} value={s}>{t(`internships.${s}`)}</option>
                            ))}
                        </select>
                    </div>

                    {app.job_url && (
                        <a
                            href={app.job_url}
                            target="_blank"
                            rel="noreferrer"
                            style={{ fontSize: '0.85rem' }}
                        >
                            {t('internships.view_job_posting')}
                        </a>
                    )}

                    {app.salary_range && (
                        <p style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '0.5rem' }}>
                            💰 {app.salary_range}
                        </p>
                    )}

                    <div className="notes-section">
                        <strong>{t('internships.notes')} ({app.notes?.length || 0})</strong>
                        {app.notes?.map(note => (
                            <p key={note.id} className="note-item">{note.note_text}</p>
                        ))}

                        {showNoteForm ? (
                            <div style={{ marginTop: '0.5rem' }}>
                                <textarea
                                    value={noteText}
                                    onChange={e => setNoteText(e.target.value)}
                                    placeholder={t('internships.add_note')}
                                    rows={3}
                                    style={{ width: '100%', padding: '0.5rem', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '0.85rem' }}
                                />
                                <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    <button
                                        onClick={handleAddNote}
                                        style={{ flex: 1, padding: '0.4rem', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' }}
                                    >
                                        {t('common.save')}
                                    </button>
                                    <button
                                        onClick={() => setShowNoteForm(false)}
                                        style={{ flex: 1, padding: '0.4rem', background: '#f1f5f9', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' }}
                                    >
                                        {t('common.cancel')}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <button
                                onClick={() => setShowNoteForm(true)}
                                style={{ marginTop: '0.5rem', padding: '0.3rem 0.6rem', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' }}
                            >
                                {t('internships.add_note_button')}
                            </button>
                        )}
                    </div>

                    <button
                        onClick={() => onDelete(app.id)}
                        className="btn-danger"
                        style={{ marginTop: '0.75rem', width: '100%' }}
                    >
                        {t('internships.delete_application')}
                    </button>
                </div>
            )}
        </div>
    );
}

export { STATUS_COLORS };
export default KanbanCard;